class VisitTimeProposition {
  constructor(visitId, firstProposition, secondProposition) {
    this.visitId = visitId;
    this.firstProposition = firstProposition;
    this.secondProposition = secondProposition;
  }
}

export default VisitTimeProposition;
